<div class="basicrow">
        <div class="basicrow" *ngIf="equ_descr != null && instal_equi > 0">
          <div class="userinfo alterno">
            <div class="basicrow">
              <div class="basicrow f-bmed roboto-b m-bott ">
                Equipo a Plazos
              </div>
              <div class="redstat">
                <div class="autorow roboto-r pull-left ajuste1">
                  {{equ_descr}}
                </div>
                <div class="autorow roboto-b pull-right ajuste2">
                  {{cuo_val |currency}}
                </div>
              </div>
              <div class="redstat m-top-ii">
                <div class="autorow roboto-r pull-left ajuste1">
                  Pagos restantes de Equipo
                </div>
                <div class="autorow roboto-b pull-right ajuste2">
                  {{instal_equi}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="basicrow  lessm-i" *ngIf="addi_serv.length > 0">
          <div *ngIf="instal_equi>0">
            <div class="userinfo servi-ad margin-top-sva servad-1">
              <div class="basicrow">
                <div class="basicrow f-bmed roboto-b ">
                  Servicios Adicionales
                </div>
                <div class="redstat m-top-ii" *ngFor="let sva of addi_serv; let j= index">
                  <div class="autorow roboto-r pull-left ajuste1">
                    {{sva.sOCDescField}}
                  </div>
                  <div class="autorow roboto-b pull-right ajuste2">
                    {{sva.socRateField | currency}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="instal_equi==0">
            <div class="userinfo servi-ad1">
              <div class="basicrow">
                <div class="basicrow f-bmed roboto-b ">
                  Servicios Adicionales
                </div>
                <div class="redstat m-top-ii" *ngFor="let sva of addi_serv; let j= index">
                  <div class="autorow roboto-r pull-left ajuste1">
                    {{sva.sOCDescField}}
                  </div>
                  <div class="autorow roboto-b pull-right ajuste2">
                    {{sva.socRateField | currency}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="instal_equi==null">
            <div class="userinfo servi-ad2">
              <div class="basicrow">
                <div class="basicrow f-bmed roboto-b ">
                  Servicios Adicionales
                </div>
                <div class="redstat m-top-ii" *ngFor="let sva of this.addi_serv; let j= index">
                  <div class="autorow roboto-r pull-left ajuste1">
                    {{sva.sOCDescField}}
                  </div>
                  <div class="autorow roboto-b pull-right ajuste2">
                    {{sva.socRateField | currency}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>